import Vue from 'vue'
import App from './App.vue'
import router from './router'
import BootstrapVue from 'bootstrap-vue'
import VueTranslate from 'vue-translate-plugin';

import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faCog, faReply, faPlus, faMinus, faSpinner
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

// Load SCSS file directly using Sass Loader
import "@/scss/app.scss"

Vue.config.productionTip = false

// Prepare FontAwesome icons for use in app
// Import and add to library only icons that will actually be used
library.add(faCog, faReply, faPlus, faMinus, faSpinner)

// Register components globally in app
Vue.component('font-awesome-icon', FontAwesomeIcon);

// Tell Vue to use defined libraries
Vue.use(BootstrapVue)

// Translate text in app
Vue.use(VueTranslate);

Vue.locales({
  da_DK: {
    'What is on the menu?': 'Hvad står menuen på?',
    'Let us help you find the perfect wine': 'Lad os hjælpe med at finde den perfekte vin',
    'That sounds delicious!': 'Det lyder virkelig lækkert!',
    'Complete the course with the right wine': 'Fuldend måltidet med den helt rigtige vin',
    'See our recommendations': 'Se lagerets udvalg her',
    'Take the test again': 'Tag testen igen',
    'Start': 'Start',
    'Next question': 'Næste spørgsmål',
    'or...': 'eller...',
    'You can pick a maximum of': 'Du kan højest vælge',
    'options': 'ting'
  }
});

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
